module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-wrapper"
  }, [(_vm.isHovered) ? _c('div', {
    staticClass: "card w-100"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title info-title"
  }, [_vm._v("Version")]), _vm._v(" "), _c('p', {
    staticClass: "card-text text-sm-center"
  }, [_vm._v(_vm._s(_vm.version))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info-version-box",
    on: {
      "mouseover": function($event) {
        _vm.isHovered = true
      },
      "mouseleave": function($event) {
        _vm.isHovered = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/components-icons/info.svg"),
      "alt": "icone de informação"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9f6c85a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/interfaces/components/AppVersion.vue
// module id = 270
// module chunks = 0